import React from 'react';
import { Button } from './ui/button';
import { products, catalogUrl } from '../data/mock';
import { Download } from 'lucide-react';

const Products = () => {
  const handleDownloadCatalog = () => {
    window.open(catalogUrl, '_blank');
  };

  return (
    <section className="block-light" id="productos">
      <div className="container">
        <div className="section-header">
          <h2>Nuestros suplementos destacados</h2>
          <p>
            Te ayudamos a elegir lo que sí tiene sentido para ti, sin compras innecesarias y con opciones al alcance.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              {product.image ? (
                <div className="product-image-container product-bg-light">
                  <img 
                    src={product.image} 
                    alt={product.name} 
                    className="product-image"
                  />
                </div>
              ) : (
                <div className="product-image-container product-coming-soon">
                  <div className="coming-soon-placeholder">
                    <p className="coming-soon-text">Próximamente</p>
                  </div>
                </div>
              )}
              <div className="product-content">
                <h3 className="!font-sans">{product.name}</h3>
                <p>{product.description}</p>
                <p className="body-small">{product.benefits}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="catalog-cta">
          <p>Contamos con muchos más productos para tus necesidades específicas</p>
          <Button 
            className="btn-primary" 
            onClick={handleDownloadCatalog}
          >
            <Download className="mr-2" size={18} />
            Descargar catálogo completo
          </Button>
        </div>

        <div className="disclaimer">
          <p>
            <strong>Nota importante:</strong> La información que compartimos es educativa y no reemplaza consejo médico. Si estás embarazada, lactando, tomas medicación o tienes una condición de salud, consulta con un profesional.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Products;